import script from "./VolverButton.vue?vue&type=script&setup=true&lang=js"
export * from "./VolverButton.vue?vue&type=script&setup=true&lang=js"

import "./VolverButton.vue?vue&type=style&index=0&id=43548974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43548974"]])

export default __exports__